export default __webpack_public_path__ + "static/media/leftArrow.9193e862.svg";